import React, { useEffect, useRef } from "react";
import { vrImages } from "../assets/Json/homePageData";
import {Paper} from "@mui/material"
import ReactPanallumVr from "./ReactPanallumVr";
const Vr360 = () => {


  return (
     <>
        
          {vrImages.map((details,idx) => {
           return(
           <div className="p-4">

            <Paper elevation={3} >
             <div className="row p-4">
               <div className="col-md-4 p-2">
                 <ReactPanallumVr image={details} idx={idx} />
               </div>

               <div className="col-md-8 p-2">

                 <h6>Experience Architecture in 360°</h6>
                 <p>Step inside our designs like never before! Immerse yourself in a 360° virtual reality experience that brings our architectural concepts to life.</p>
                 <ul style={{ lineHeight: "30px" }}>
                   <li><b>See Every Detail:</b>  Experience the materials, textures, lighting, and spatial flow as if you're already there.</li>
                   <li><b>Explore Spaces Virtually:</b> Walk through your future home, office, or commercial space before construction even begins.</li>
                   <li><b>Interactive Design Reviews:</b>Collaborate and make informed decisions with a fully immersive view of your project.</li>
                 </ul>
                 {/* <Link className="btn btn-primary" to={"/vr-360"}> Explore 360 </Link>           */}

               </div>
             </div>
             </Paper>
           </div>
 
           )
          })}

      

     </>
  );
};

export default Vr360;
